import React, { ReactNode } from 'react';
import { Group } from '@mantine/core';

type Justification = 'start' | 'center' | 'end' | 'space-between';

const justificationToMantineJustify: Record<Justification, 'flex-start' | 'center' | 'flex-end' | 'space-between'> = {
	start: 'flex-start',
	end: 'flex-end',
	center: 'center',
	'space-between': 'space-between',
};

interface ActionBarProps {
	justify?: Justification;
	children: ReactNode;
}

export const ActionBar: React.FC<React.PropsWithChildren<ActionBarProps>> = (props) => {
	const { justify = 'start', children } = props;

	return (
		<Group justify={justificationToMantineJustify[justify]} className="action-bar">
			{children}
		</Group>
	);
};
